import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'evolution',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'patient-covid-evolution',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [                   
                    {                           
                        transKey: 'breadcrumbs.patient-profile-evolution',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "patients-profile-index" */ '@/modules/patient-profile/evolution/views/MyEvolution.vue')
        }
    ]
}